export const isPWASupported = (): boolean => {
	return 'serviceWorker' in navigator && 'beforeinstallprompt' in window;
};
